import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RangePaginationState } from 'components/basic/Pagination';
import StageActionToolbar from '../generic/StageActionToolbar';

import '../../../../../styles/Icons.scss';

interface PolicyDetailsCommercialApplicationLocationStagingPageArgs {
    conversionId: string,
}

type PolicyDetailsCommercialApplicationLocationStagingPageProps = RouteComponentProps<PolicyDetailsCommercialApplicationLocationStagingPageArgs>;

interface PolicyDetailsCommercialApplicationLocationStagingPageState {
    destinationCodes: any;
    filter: string;

    pagination: RangePaginationState;
}

export class PolicyDetailsCommercialApplicationLocationStagingPage extends React.Component<PolicyDetailsCommercialApplicationLocationStagingPageProps, PolicyDetailsCommercialApplicationLocationStagingPageState>{

    constructor(props: PolicyDetailsCommercialApplicationLocationStagingPageProps) {
        super(props)
        this.state = {
            destinationCodes: [],
            filter: '',

            pagination: {
                pageSize: 25,
                pageNumber: 0,
            }
        }
    }

    componentDidMount() {
        //this.client.get(this.props.match.params.conversionId, '')
        //    .then((response) => {
        //        this.setState({
        //            items: response!
        //        })
        //    })
        //    .catch(error => { })
    }

    public render() {
        const conversionId = this.props.match.params.conversionId;
        return (
            <>
                <StageActionToolbar
                    conversionId={conversionId}
                    sectionId='commercialapplication'
                    tierGate='tier4'
                    noMapping={true}
                    filter={this.state.filter}
                />

            </>
        );
    }
}